/**
 * Missing — empty alveolar socket with a dashed outline where the tooth used
 * to be. A soft red × sits in the middle to communicate extraction at a
 * glance. Meant to be rendered *instead of* the natural crown/root by the
 * parent, so the tooth is visually absent.
 */
export default function Missing() {
  return (
    <g style={{ pointerEvents: "none" }}>
      {/* Ghost socket outline */}
      <path
        d="M 14 32
           C 14 24 22 20 30 20
           C 38 20 46 24 46 32
           L 46 90
           C 46 96 40 100 30 100
           C 20 100 14 96 14 90 Z"
        fill="#F5F1EA"
        stroke="#8892A0"
        strokeWidth={1}
        strokeDasharray="3 2.5"
        opacity={0.85}
      />
      {/* Big central × */}
      <path d="M 22 46 L 38 78 M 38 46 L 22 78"
            stroke="#B94A48" strokeWidth={2.4} strokeLinecap="round" />
      {/* Root ghost */}
      <path d="M 24 100 L 22 122 Q 30 126 38 122 L 36 100 Z"
            fill="none" stroke="#8892A0" strokeDasharray="2 2.5"
            strokeWidth={0.9} opacity={0.6} />
    </g>
  );
}
